import writableTheme from './writableTheme';

export { writableTheme };

export default writableTheme;
